<template>
  <div class="w-100 bg-white min-vh-100">
    <Navbar v-if="page_design_type === 'WIDE_VIEW'" />
    <block v-if="page_design_type === 'WIDE_VIEW'" :height="83"></block>

    <b-row class="justify-content-center" no-gutters>
      <b-col cols="12" sm="8" md="6" lg="5" xl="4" class="bg-white" :class="{ 'fit-to-screen' : page_design_type === 'MOBILE_VIEW' }">
        <div class="w-100 bg-white" :class="{ 'fit-to-screen' : page_design_type === 'MOBILE_VIEW' }">
        <div v-if="is_load" class="w-100 text-center py-5">
          <loader />
        </div>
        <template v-else>
          <div class="w-100 py-5 px-4" v-if="error != ''">
            <ErrorMessage :message="error" />
          </div>
          <template v-else>
            <span id="top-section"></span>
            <!-- NAVBAR (Only Mobile View) -->
            <div class="w-100" v-if="page_design_type === 'MOBILE_VIEW'">
              <div class="bg-green w-100" style="height: 180px;">
                <div class="w-100 py-3 z-index-1041">
                  <div class="ga-container py-2">
                    <div class="d-flex">
                      <div class="lh-1 align-self-center mr-3">
                        <svg @click="goToPage('PosHome')" class="lh-1 cursor-pointer" width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_581_18)">
                            <path
                              d="M0.0294189 8.00744C0.0294189 8.27112 0.145437 8.5137 0.356381 8.7141L7.35969 15.7069C7.57064 15.9073 7.79213 16.0022 8.04526 16.0022C8.56207 16.0022 8.97341 15.6225 8.97341 15.0951C8.97341 14.842 8.87848 14.5889 8.70973 14.4306L6.34717 12.0259L2.1705 8.21839L1.949 8.7352L5.34519 8.94614H18.6874C19.2358 8.94614 19.6155 8.5559 19.6155 8.00744C19.6155 7.45899 19.2358 7.06874 18.6874 7.06874H5.34519L1.949 7.27969L2.1705 7.80705L6.34717 3.98898L8.70973 1.58422C8.87848 1.41546 8.97341 1.17288 8.97341 0.919749C8.97341 0.392393 8.56207 0.0126953 8.04526 0.0126953C7.79213 0.0126953 7.57064 0.0970726 7.3386 0.32911L0.356381 7.30079C0.145437 7.50118 0.0294189 7.74376 0.0294189 8.00744Z"
                              fill="white" />
                          </g>
                          <defs>
                            <clipPath id="clip0_581_18">
                              <rect width="19.5861" height="16" fill="white" transform="translate(0.0294189 0.0126953)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="lh-1 align-self-center">
                        <p class="body-1-4 mb-0 text-white">Table Reservation</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="ga-container position-relative" :class="{ 'pb-5' : page_design_type === 'WIDE_VIEW' }" :style="page_design_type === 'MOBILE_VIEW' ? 'top:-80px;' : ''">
              <div class="w-100 radius-12 bg-white p-4 border-form box-shadow-light-aff" :class="{ 'my-4' : page_design_type === 'WIDE_VIEW' }">
                <div class="row">
                  <div class="col-9">
                    <p class="heading-6 mb-0">{{ general_data.name }}</p>
                    <p class="body-3-3-1 mb-0">{{ general_data.location }}</p>
                  </div>
                  <div class="col-3">
                    <img :src="getMerchant.image_url" class="w-100">
                  </div>
                  <div class="col-12">
                    <div class="my-4 border-b-form"></div>
                  </div>
                  <div class="col-12">
                    <div class="w-100 mb-4">
                      <p class="color-black body-2 mb-2">Reservation Status</p>
                      <div class="row no-gutters">
                        <div class="col-9 align-self-center">
                          <div class="pr-3">
                            <p class="mb-0 sub-heading-1-2" :class="trx.status_detail.class">{{trx.status_detail.status}}</p>
                            <p class="mb-0 body-3-3">{{trx.status_detail.msg}}</p>
                          </div>
                        </div>
                        <div class="col-3 align-self-center" v-if="trx.status == 'PENDING'">
                          <state-button variant="primary" block size="sm" :click="checkStatus">Check Status</state-button>
                        </div>
                      </div>
                    </div>
                    <div class="w-100 mb-4 border-b-form">
                      <p class="my-3 color-black body-2">Reservation Detail</p>
                      <div class="w-100">
                        <div class="d-flex mb-4">
                          <div class="align-self-top">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_633_18)">
                                <path
                                  d="M2.48995 10.9506H8.43455C10.0902 10.9506 10.9245 10.1162 10.9245 8.39542V2.56814C10.9245 0.847341 10.0902 0.0260468 8.43455 0.0260468H2.48995C0.83433 0.0260468 0 0.847341 0 2.56814V8.39542C0 10.1162 0.83433 10.9506 2.48995 10.9506ZM2.51603 9.11243C2.05975 9.11243 1.83813 8.87777 1.83813 8.39542V2.56814C1.83813 2.09884 2.05975 1.86418 2.51603 1.86418H8.39545C8.85172 1.86418 9.08638 2.09884 9.08638 2.56814V8.39542C9.08638 8.87777 8.85172 9.11243 8.39545 9.11243H2.51603ZM4.34112 6.85712H6.57035C6.75285 6.85712 6.83107 6.7789 6.83107 6.55728V4.39324C6.83107 4.18466 6.75285 4.10645 6.57035 4.10645H4.34112C4.14557 4.10645 4.0804 4.18466 4.0804 4.39324V6.55728C4.0804 6.7789 4.14557 6.85712 4.34112 6.85712ZM15.5785 10.9506H21.51C23.1657 10.9506 24 10.1162 24 8.39542V2.56814C24 0.847341 23.1657 0.0260468 21.51 0.0260468H15.5785C13.9098 0.0260468 13.0755 0.847341 13.0755 2.56814V8.39542C13.0755 10.1162 13.9098 10.9506 15.5785 10.9506ZM15.6045 9.11243C15.1353 9.11243 14.9136 8.87777 14.9136 8.39542V2.56814C14.9136 2.09884 15.1353 1.86418 15.6045 1.86418H21.484C21.9403 1.86418 22.1619 2.09884 22.1619 2.56814V8.39542C22.1619 8.87777 21.9403 9.11243 21.484 9.11243H15.6045ZM17.4949 6.85712H19.7241C19.9196 6.85712 19.9979 6.7789 19.9979 6.55728V4.39324C19.9979 4.18466 19.9196 4.10645 19.7241 4.10645H17.4949C17.3123 4.10645 17.2472 4.18466 17.2472 4.39324V6.55728C17.2472 6.7789 17.3123 6.85712 17.4949 6.85712ZM2.48995 24.0261H8.43455C10.0902 24.0261 10.9245 23.2048 10.9245 21.484V15.6437C10.9245 13.9358 10.0902 13.1015 8.43455 13.1015H2.48995C0.83433 13.1015 0 13.9358 0 15.6437V21.484C0 23.2048 0.83433 24.0261 2.48995 24.0261ZM2.51603 22.1879C2.05975 22.1879 1.83813 21.9533 1.83813 21.484V15.6567C1.83813 15.1743 2.05975 14.9397 2.51603 14.9397H8.39545C8.85172 14.9397 9.08638 15.1743 9.08638 15.6567V21.484C9.08638 21.9533 8.85172 22.1879 8.39545 22.1879H2.51603ZM4.34112 19.9457H6.57035C6.75285 19.9457 6.83107 19.8675 6.83107 19.6328V17.4817C6.83107 17.2732 6.75285 17.195 6.57035 17.195H4.34112C4.14557 17.195 4.0804 17.2732 4.0804 17.4817V19.6328C4.0804 19.8675 4.14557 19.9457 4.34112 19.9457ZM13.962 16.478H16.1912C16.3738 16.478 16.452 16.3998 16.452 16.1782V14.0142C16.452 13.8056 16.3738 13.7273 16.1912 13.7273H13.962C13.7664 13.7273 13.7013 13.8056 13.7013 14.0142V16.1782C13.7013 16.3998 13.7664 16.478 13.962 16.478ZM20.8843 16.478H23.1135C23.296 16.478 23.3743 16.3998 23.3743 16.1782V14.0142C23.3743 13.8056 23.296 13.7273 23.1135 13.7273H20.8843C20.6888 13.7273 20.6236 13.8056 20.6236 14.0142V16.1782C20.6236 16.3998 20.6888 16.478 20.8843 16.478ZM17.4557 19.9457H19.685C19.8675 19.9457 19.9457 19.8675 19.9457 19.6328V17.4817C19.9457 17.2732 19.8675 17.195 19.685 17.195H17.4557C17.2602 17.195 17.195 17.2732 17.195 17.4817V19.6328C17.195 19.8675 17.2602 19.9457 17.4557 19.9457ZM13.962 23.4004H16.1912C16.3738 23.4004 16.452 23.3221 16.452 23.1005V20.9364C16.452 20.7278 16.3738 20.6496 16.1912 20.6496H13.962C13.7664 20.6496 13.7013 20.7278 13.7013 20.9364V23.1005C13.7013 23.3221 13.7664 23.4004 13.962 23.4004ZM20.8843 23.4004H23.1135C23.296 23.4004 23.3743 23.3221 23.3743 23.1005V20.9364C23.3743 20.7278 23.296 20.6496 23.1135 20.6496H20.8843C20.6888 20.6496 20.6236 20.7278 20.6236 20.9364V23.1005C20.6236 23.3221 20.6888 23.4004 20.8843 23.4004Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_633_18">
                                  <rect width="24" height="24.0261" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="align-self-top pl-3">
                            <p class="mb-1 text-green sub-heading-1-1 lh-1">{{trx.reservation_id}}</p>
                            <p class="mb-0 body-3-3 color-black">Reservation ID</p>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div class="align-self-top">
                            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_367_25)">
                                <path
                                  d="M3.78123 22.1937H20.2308C22.7476 22.1937 24 20.9413 24 18.4605V3.75715C24 1.27647 22.7476 0.024086 20.2308 0.024086H3.78123C1.26443 0.024086 0 1.26443 0 3.75715V18.4605C0 20.9533 1.26443 22.1937 3.78123 22.1937ZM3.6006 20.2548C2.52885 20.2548 1.93878 19.6889 1.93878 18.569V7.21324C1.93878 6.10537 2.52885 5.52734 3.6006 5.52734H20.3873C21.4591 5.52734 22.0612 6.10537 22.0612 7.21324V18.569C22.0612 19.6889 21.4591 20.2548 20.3873 20.2548H3.6006ZM9.65779 9.85047H10.3682C10.7898 9.85047 10.9222 9.73004 10.9222 9.30856V8.59809C10.9222 8.17661 10.7898 8.04414 10.3682 8.04414H9.65779C9.23631 8.04414 9.09181 8.17661 9.09181 8.59809V9.30856C9.09181 9.73004 9.23631 9.85047 9.65779 9.85047ZM13.6558 9.85047H14.3663C14.7877 9.85047 14.9322 9.73004 14.9322 9.30856V8.59809C14.9322 8.17661 14.7877 8.04414 14.3663 8.04414H13.6558C13.2343 8.04414 13.0898 8.17661 13.0898 8.59809V9.30856C13.0898 9.73004 13.2343 9.85047 13.6558 9.85047ZM17.6538 9.85047H18.3643C18.7857 9.85047 18.9303 9.73004 18.9303 9.30856V8.59809C18.9303 8.17661 18.7857 8.04414 18.3643 8.04414H17.6538C17.2323 8.04414 17.0998 8.17661 17.0998 8.59809V9.30856C17.0998 9.73004 17.2323 9.85047 17.6538 9.85047ZM5.6598 13.7883H6.35825C6.79177 13.7883 6.92422 13.6678 6.92422 13.2463V12.5358C6.92422 12.1144 6.79177 11.994 6.35825 11.994H5.6598C5.22629 11.994 5.09382 12.1144 5.09382 12.5358V13.2463C5.09382 13.6678 5.22629 13.7883 5.6598 13.7883ZM9.65779 13.7883H10.3682C10.7898 13.7883 10.9222 13.6678 10.9222 13.2463V12.5358C10.9222 12.1144 10.7898 11.994 10.3682 11.994H9.65779C9.23631 11.994 9.09181 12.1144 9.09181 12.5358V13.2463C9.09181 13.6678 9.23631 13.7883 9.65779 13.7883ZM13.6558 13.7883H14.3663C14.7877 13.7883 14.9322 13.6678 14.9322 13.2463V12.5358C14.9322 12.1144 14.7877 11.994 14.3663 11.994H13.6558C13.2343 11.994 13.0898 12.1144 13.0898 12.5358V13.2463C13.0898 13.6678 13.2343 13.7883 13.6558 13.7883ZM17.6538 13.7883H18.3643C18.7857 13.7883 18.9303 13.6678 18.9303 13.2463V12.5358C18.9303 12.1144 18.7857 11.994 18.3643 11.994H17.6538C17.2323 11.994 17.0998 12.1144 17.0998 12.5358V13.2463C17.0998 13.6678 17.2323 13.7883 17.6538 13.7883ZM5.6598 17.738H6.35825C6.79177 17.738 6.92422 17.6056 6.92422 17.1842V16.4736C6.92422 16.0522 6.79177 15.9317 6.35825 15.9317H5.6598C5.22629 15.9317 5.09382 16.0522 5.09382 16.4736V17.1842C5.09382 17.6056 5.22629 17.738 5.6598 17.738ZM9.65779 17.738H10.3682C10.7898 17.738 10.9222 17.6056 10.9222 17.1842V16.4736C10.9222 16.0522 10.7898 15.9317 10.3682 15.9317H9.65779C9.23631 15.9317 9.09181 16.0522 9.09181 16.4736V17.1842C9.09181 17.6056 9.23631 17.738 9.65779 17.738ZM13.6558 17.738H14.3663C14.7877 17.738 14.9322 17.6056 14.9322 17.1842V16.4736C14.9322 16.0522 14.7877 15.9317 14.3663 15.9317H13.6558C13.2343 15.9317 13.0898 16.0522 13.0898 16.4736V17.1842C13.0898 17.6056 13.2343 17.738 13.6558 17.738Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_367_25">
                                  <rect width="24" height="22.1937" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="align-self-top pl-3">
                            <p class="mb-1 text-green sub-heading-1-1 lh-1">{{$customFormatDateTime(trx.book_date,'null','dddd')}}</p>
                            <p class="mb-0 body-3-3 color-black">{{ $customFormatDateTime(trx.book_date,'null','D MMMM YYYY') }}</p>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div class="align-self-top">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_251_6)">
                                <path
                                  d="M12 24C18.5648 24 24 18.553 24 12C24 5.4353 18.553 0 11.9883 0C5.4353 0 0 5.4353 0 12C0 18.553 5.44707 24 12 24ZM12 22.0001C6.44708 22.0001 2.01177 17.553 2.01177 12C2.01177 6.44708 6.43531 2.00001 11.9883 2.00001C17.5413 2.00001 22.0001 6.44708 22.0001 12C22.0001 17.553 17.553 22.0001 12 22.0001Z"
                                  class="fill-primary" />
                                <path
                                  d="M5.84708 13.2707H11.9883C12.4471 13.2707 12.8118 12.9177 12.8118 12.4471V4.5177C12.8118 4.05887 12.4471 3.70593 11.9883 3.70593C11.5295 3.70593 11.1765 4.05887 11.1765 4.5177V11.6353H5.84708C5.37649 11.6353 5.02355 11.9883 5.02355 12.4471C5.02355 12.9177 5.37649 13.2707 5.84708 13.2707Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_251_6">
                                  <rect width="24" height="24.0118" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="align-self-top pl-3">
                            <p class="mb-1 text-green sub-heading-1-1 lh-1">{{$customFormatDateTime(trx.book_date,'null','HH:mm')}}</p>
                            <p class="mb-0 body-3-3 color-black">According to local time</p>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div class="align-self-top">
                            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_634_22)">
                                <path
                                  d="M6.2423 8.78853C7.93428 8.78853 9.32239 7.269 9.32239 5.40452C9.32239 3.58111 7.95075 2.11089 6.2423 2.11089C4.55031 2.11089 3.16222 3.60575 3.16222 5.42095C3.16222 7.2772 4.55031 8.78853 6.2423 8.78853ZM6.2423 7.5647C5.24024 7.5647 4.38603 6.6037 4.38603 5.42095C4.38603 4.26283 5.23203 3.3347 6.2423 3.3347C7.2772 3.3347 8.10677 4.2464 8.10677 5.40452C8.10677 6.6037 7.2526 7.5647 6.2423 7.5647ZM1.67556 16.3204H10.8008C11.9179 16.3204 12.4682 15.8686 12.4682 14.9486C12.4682 12.2218 9.68377 9.72485 6.23408 9.72485C2.79261 9.72485 0 12.2218 0 14.9486C0 15.8686 0.558521 16.3204 1.67556 16.3204ZM1.47023 15.1047C1.30595 15.1047 1.22382 15.039 1.22382 14.8748C1.22382 12.8378 3.54825 10.9405 6.23408 10.9405C8.92814 10.9405 11.2444 12.8378 11.2444 14.8748C11.2444 15.039 11.1704 15.1047 11.0061 15.1047H1.47023Z"
                                  class="fill-primary" />
                                <path
                                  d="M10.5462 17.4374H20.8624C23.0472 17.4374 24 16.4024 24 15.0062C24 12.2136 20.7638 8.61603 15.7043 8.61603C10.6365 8.61603 7.4086 12.2136 7.4086 15.0062C7.4086 16.4024 8.35319 17.4374 10.5462 17.4374ZM15.7043 8.71458C17.6591 8.71458 19.2526 6.98152 19.2526 4.86242C19.2526 2.75975 17.6673 1.10883 15.7043 1.10883C13.7577 1.10883 12.1561 2.79261 12.1561 4.87885C12.1561 6.98973 13.7577 8.71458 15.7043 8.71458Z"
                                  fill="white" />
                                <path
                                  d="M15.7043 8.71458C17.6591 8.71458 19.2526 6.98152 19.2526 4.86242C19.2526 2.75975 17.6673 1.10883 15.7043 1.10883C13.7577 1.10883 12.1561 2.79261 12.1561 4.87885C12.1561 6.98973 13.7577 8.71458 15.7043 8.71458ZM15.7043 7.47435C14.5051 7.47435 13.4785 6.33265 13.4785 4.87885C13.4785 3.44969 14.4887 2.34907 15.7043 2.34907C16.9281 2.34907 17.9302 3.42505 17.9302 4.86242C17.9302 6.31622 16.9199 7.47435 15.7043 7.47435ZM10.5462 16.3204H20.8624C22.2258 16.3204 22.8747 15.9096 22.8747 15.0062C22.8747 12.8542 20.156 9.74124 15.7043 9.74124C11.2444 9.74124 8.5257 12.8542 8.5257 15.0062C8.5257 15.9096 9.17451 16.3204 10.5462 16.3204ZM10.152 15.0801C9.93841 15.0801 9.84806 15.0226 9.84806 14.8501C9.84806 13.4949 11.9343 10.9815 15.7043 10.9815C19.4661 10.9815 21.5524 13.4949 21.5524 14.8501C21.5524 15.0226 21.4702 15.0801 21.2567 15.0801H10.152Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_634_22">
                                  <rect width="24" height="17.4374" fill="white" />
                                </clipPath>
                              </defs>
                              </svg>
                          </div>
                          <div class="align-self-top pl-3">
                            <p class="mb-1 text-green sub-heading-1-1 lh-1">For {{ trx.people }} {{ trx.people > 1 ? 'People' : 'Person' }}</p>
                            <p class="mb-0 body-3-3 color-black">{{ trx.person_detail }}</p>
                          </div>
                        </div>

                        <div class="d-flex mb-4" v-if="$isNotEmpty(trx.table_name)">
                          <div class="align-self-top">
                            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_636_33)">
                                <path
                                  d="M3.12309 17.1571H21.1753C22.9557 17.1571 24 16.1227 24 14.0738V3.09325C24 1.04435 22.9458 0.00994873 20.877 0.00994873H2.8247C1.04435 0.00994873 0 1.04435 0 3.09325V14.0738C0 16.1227 1.05429 17.1571 3.12309 17.1571ZM3.06342 15.6354C2.07874 15.6354 1.52176 15.0883 1.52176 14.0638V3.0833C1.52176 2.0688 2.07874 1.53171 3.06342 1.53171H20.9266C21.9113 1.53171 22.4783 2.0688 22.4783 3.09325V14.0738C22.4783 15.0883 21.9113 15.6354 20.9266 15.6354H3.06342ZM11.995 11.1993C12.6316 11.1993 13.2483 10.9607 13.8152 10.4435L23.1745 2.01907L22.1401 0.974726L12.9499 9.2599C12.6415 9.53837 12.3232 9.66763 11.995 9.66763C11.6668 9.66763 11.3486 9.53837 11.0402 9.2599L1.84998 0.974726L0.815584 2.01907L10.1749 10.4435C10.7418 10.9607 11.3585 11.1993 11.995 11.1993ZM1.99918 15.884L9.06095 8.81227L8.02653 7.77788L0.964777 14.8397L1.99918 15.884ZM22.0108 15.894L23.0452 14.8496L15.9735 7.77788L14.9291 8.81227L22.0108 15.894Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_636_33">
                                  <rect width="24" height="17.1571" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="align-self-top pl-3">
                            <p class="mb-1 text-green sub-heading-1-1 lh-1">{{ trx.table_name }}</p>
                            <p class="mb-0 body-3-3 color-black">Note from restaurant</p>
                          </div>
                        </div>

                        <div class="d-flex mb-4">
                          <div class="align-self-center">
                            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_635_28)">
                                <path
                                  d="M3.78123 22.1937H20.2308C22.7476 22.1937 24 20.9413 24 18.4605V3.75715C24 1.27647 22.7476 0.024086 20.2308 0.024086H3.78123C1.26443 0.024086 0 1.26443 0 3.75715V18.4605C0 20.9533 1.26443 22.1937 3.78123 22.1937ZM3.6006 20.2548C2.52885 20.2548 1.93878 19.6889 1.93878 18.569V7.21324C1.93878 6.10537 2.52885 5.52734 3.6006 5.52734H20.3873C21.4591 5.52734 22.0612 6.10537 22.0612 7.21324V18.569C22.0612 19.6889 21.4591 20.2548 20.3873 20.2548H3.6006Z"
                                  class="fill-primary" />
                                <path
                                  d="M5.69594 10.007H18.3402C18.7616 10.007 19.0868 9.66983 19.0868 9.24836C19.0868 8.83892 18.7616 8.52583 18.3402 8.52583H5.69594C5.25038 8.52583 4.93729 8.83892 4.93729 9.24836C4.93729 9.66983 5.25038 10.007 5.69594 10.007ZM5.69594 13.6317H18.3402C18.7616 13.6317 19.0868 13.3186 19.0868 12.9092C19.0868 12.4756 18.7616 12.1505 18.3402 12.1505H5.69594C5.25038 12.1505 4.93729 12.4756 4.93729 12.9092C4.93729 13.3186 5.25038 13.6317 5.69594 13.6317ZM5.69594 17.2564H13.7281C14.1495 17.2564 14.4746 16.9433 14.4746 16.5338C14.4746 16.1124 14.1495 15.7752 13.7281 15.7752H5.69594C5.25038 15.7752 4.93729 16.1124 4.93729 16.5338C4.93729 16.9433 5.25038 17.2564 5.69594 17.2564Z"
                                  class="fill-primary" />
                              </g>
                              <defs>
                                <clipPath id="clip0_635_28">
                                  <rect width="24" height="22.1937" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                          </div>
                          <div class="align-self-center pl-3">
                            <p class="mb-0 body-2-2 lh-1">{{ trx.note }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="w-100">
                      <p class="mt-4 mb-2 color-black body-2">Contact Detail</p>
                      <p class="mb-0 sub-heading-1-1 color-black">{{trx.customer_detail.title}} {{trx.customer_detail.first_name}} {{trx.customer_detail.last_name}}</p>
                      <p class="mb-0 body-2-2 text-light-bold">{{trx.customer_detail.email}} | {{trx.customer_detail.phone_number}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </div>
    </b-col>
    </b-row>
    <template v-if="page_design_type === 'WIDE_VIEW'">
      <Footer />
    </template>
  </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex';
  import {
    get
  } from '@/services/index.js'
  import Navbar from '@/components/hotel/concierge/general/Navbar';
  import Footer from '@/components/hotel/concierge/general/Footer';
import { applyResolvedTitle } from '../../../../utils/titleService';
import { trackPageViewAfterDataLoaded } from '../../../../utils/analytics';

  export default {
    components: {
      Navbar,
      Footer
    },
    data() {
      return {
        is_load: true,
        error: '',
        general_data: {},
        trx: {}
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getCurrentUser',
        'getOutletTrxCustomerDetail',
        'getMetaTitleTemplate'
      ]),
      pos_code() {
        return this.$route.params.pos_code
      },
      tx_order_id(){
        return this.$route.params.tx_order_id
      },
      page_design_type() {
        const page_design = this.general_data.page_design ? this.general_data.page_design : 'MOBILE_VIEW';
        return (page_design === 'WIDE_VIEW' && !this.$is_mobile_view) ? 'WIDE_VIEW' : 'MOBILE_VIEW'
      }
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData() {
        this.is_load = true
        let func_exe = [this.loadGeneralData(),this.loadDetailTrx()]
        Promise.all(func_exe)
        .catch(err=>this.error = err)
        .finally(() => {
          this.is_load = false
          setTimeout(() => {
            this.$smoothScroll('top-section')
          }, 100);
        })
      },
      loadGeneralData() {
        return new Promise((success, fail) => {
          this.general_data = {}
          get("CORE_HOTEL", `merchant-pos/${this.pos_code}/general`, {
            merchant_id: this.getMerchant.id
          }).then(response => {
            let res = response.data
            if (res.success) {
              this.general_data = res.data
              this.$validatePage('CONCIERGE',this.general_data).then(()=>{
                applyResolvedTitle({router: this.$router, title: `Booking Confirmed - ${res.data.tagline}`, trackFn: () => {
                  trackPageViewAfterDataLoaded()
                }})

                success()
              }).catch(()=>fail())
            } else {
              fail(res.message)
            }
          })
        })
      },
      loadDetailTrx(){
        return new Promise((success,fail)=>{
          get("CORE_HOTEL",`merchant-pos/table-reservation/transaction/${this.tx_order_id}`,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              let parsingStatus = () => {
                if(res.data.status == 'PENDING'){
                  return {
                    status: 'Waiting for confirmation',
                    msg: 'Please wait while our staff checks your reservation',
                    class: 'text-orange'
                  }
                }else if(res.data.status == 'SUCCESS'){
                  return {
                    status: 'Confirmed',
                    msg: 'Your reservation has been confirmed. Please contact us if you have any changes',
                    class: 'text-green'
                  }
                }else if(res.data.status == 'CANCELLED'){
                  return {
                    status: 'Cancelled',
                    msg: res.data.merchant_note,
                    class: 'text-danger'
                  }
                }else{
                  return {
                    status: res.data.status,
                    msg: '',
                    class: 'text-info'
                  }
                }
              }

              let parsingGuest = () => {
                let guest = res.data.guest_detail.adult
                guest += ` ${this.$pluralWord(res.data.guest_detail.adult,'Adult')}`
                if(res.data.guest_detail.child > 0){
                  let child =  ` and ${res.data.guest_detail.child} `
                  child += this.$pluralWord(res.data.guest_detail.child,'Child')
                  guest += child
                }
                return guest
              }

              this.trx = res.data
              this.trx.status_detail = parsingStatus()
              this.trx.person_detail = parsingGuest()
              success()
            }else{
              fail(res.message)
            }
          })
        })
      },
      checkStatus(){
        return new Promise((success,fail)=>{
          this.loadDetailTrx().finally(()=>{
            success()
          })
        })
      },
      goToPage(page) {
        let route = {
          name: page,
          params: {
            merchant_code: this.getMerchant.code,
            pos_code: this.pos_code
          }
        }
        this.$router.push(route)
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/hotel/concierge/pos/BookingTableResult.vue